import React from 'react';
import moment from 'moment';
import { IPaginationPayload } from '../../../interfaces/shared/IPaginationPayload';
import { IPage } from '../../../interfaces/models/models/paginated-response.model';
import Table from '../../../shared/table';

const tableColumns = ['Reservation ID', 'Name', 'Cabin Number', 'Check in', 'Check out']

interface IGuestReservationsTable {
    rows: any;
    paginationData?: IPage;
    rowsLoading: boolean;
    setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
}

const GuestBookingHistory = ({
    rows,
    paginationData,
    rowsLoading,
    setPaginationState,
}: IGuestReservationsTable) => {
    return (
        <Table
            columns={tableColumns}
            paginationData={paginationData}
            setPaginationState={setPaginationState}
			headStyle={"!bg-[#F7F9FC] border border-[#E8F1FD]"}
			headerColsStyle={"!text-gray-500 !font-medium !font-xs"}
			containerStyle={"!my-0"}
        >
            {rowsLoading ?
                <>
                    {[...Array(4)].map((x, i) => {
                        return (
                            <tr key={i}>
                                {[...Array(tableColumns?.length || 1)].map((x, j) => {
                                    return (
                                        <td key={j} className='td-1 !min-w-[100%] text-center py-5'><span></span></td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </>
                : <>
                    {rows?.length > 0 && rows?.map((row: any, idx: number) => {
                        return (
                            <tr key={idx} className='bg-white border-b hover:bg-gray-50 cursor-pointer'>
                                <td className='px-6 py-4'>{row?.reservationId}</td>
                                <td className='px-6 py-4'>{row?.guest?.fullName}</td>
                                <td className='px-6 py-4'>{row?.room}</td>
                                <td className='px-6 py-4'>{moment(row?.checkinDate)?.format('DD/MM/YYYY')}</td>
                                <td className='px-6 py-4'>{moment(row?.checkoutDate)?.format('DD/MM/YYYY')}</td>
                            </tr>
                        )
                    })}
                </>
            }
        </Table>
    )
}

export default GuestBookingHistory;